"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var invariant = require("invariant");
var PropTypes = require("prop-types");
var React = require("react");
var react_redux_1 = require("react-redux");
var react_router_redux_1 = require("react-router-redux");
var isModifiedEvent = function (event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, target = _a.target;
            if (onClick) {
                onClick(e);
            }
            if (!e.defaultPrevented && // onClick prevented default
                e.button === 0 && // ignore right clicks
                !target && // let browser handle "target=_blank" etc.
                !isModifiedEvent(e) // ignore clicks with modifier keys
            ) {
                e.preventDefault();
                var _b = _this.props, pushUrl = _b.pushUrl, replace = _b.replace, replaceUrl = _b.replaceUrl, to = _b.to;
                if (replace) {
                    replaceUrl(to);
                }
                else {
                    pushUrl(to);
                }
            }
        };
        return _this;
    }
    Link.prototype.render = function () {
        var _a = this.props, innerRef = _a.innerRef, pushUrl = _a.pushUrl, replace = _a.replace, replaceUrl = _a.replaceUrl, to = _a.to, props = tslib_1.__rest(_a, ["innerRef", "pushUrl", "replace", "replaceUrl", "to"]);
        invariant(this.context.router, 'You should not use <Link> outside a <Router>');
        var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
        return React.createElement("a", tslib_1.__assign({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
    };
    Link.defaultProps = {
        replace: false,
    };
    Link.propTypes = {
        onClick: PropTypes.func,
        target: PropTypes.string,
        replace: PropTypes.bool,
        to: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object
        ]).isRequired,
        innerRef: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.func
        ])
    };
    Link.contextTypes = {
        router: PropTypes.shape({
            history: PropTypes.shape({
                push: PropTypes.func.isRequired,
                replace: PropTypes.func.isRequired,
                createHref: PropTypes.func.isRequired
            }).isRequired
        }).isRequired
    };
    return Link;
}(React.Component));
exports.default = react_redux_1.connect(undefined, {
    pushUrl: react_router_redux_1.push,
    replaceUrl: react_router_redux_1.replace,
})(Link);
//# sourceMappingURL=Link.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-redux-dom-link/lib/Link.js
// module id = 831
// module chunks = 0